import React from "react";
import {
  useNavigate,
} from "react-router-dom";
import { format, parseJSON } from "date-fns";
import humanize from "underscore.string/humanize";
import titleize from "underscore.string/titleize";
import { formatMoney } from "../../utils/currrency";
import { 
  ResponsiveTable,
  Paginator,
  ErrorBoundary,
  Loaders,
} from "../../components";
import { 
  usePreoffersList,
} from "../../queries/preoffer";
import usePagination from "../../hooks/usePagination";

function PreoffersList({companyId}) {
  const navigate = useNavigate();
  const pageConfig = usePagination();
  const preoffersList = usePreoffersList({...pageConfig.current, company_id: companyId})

  const openPreofferView = React.useCallback(
    (row) => navigate(`prelaunch/${row.original.slug}`),
    [navigate]
  )

  const tableData = React.useMemo(
    () => {
      if (preoffersList.isSuccess)
        return preoffersList.data.data
      else
        return []
    },
    [preoffersList]
  );


  const columns = React.useMemo(
    () => {
      if (preoffersList.isSuccess){
        return [
          { 
            Header: 'Offer name',
            accessor: 'name',
            Cell: ({value}) => titleize(value),
          },
          { 
            Header: 'Created',
            accessor: 'created_at',
            Cell: ({value}) => format(parseJSON(value), 'MMM dd, yyyy'),
          },
          {
            Header: 'Goal',
            accessor: 'goal_amount',
            Cell: ({value}) => formatMoney(value, {precision: 0}),
          },
          {
            Header: 'Amt funded',
            accessor: 'committed',
            Cell: ({value}) => formatMoney(value, {precision: 0}),
          },
          {
            Header: 'Status',
            accessor: 'status',
            Cell: ({value}) => humanize(value),
          }
        ]
      }
      else{
        return []
      }
    },
    [preoffersList]
  );

  if (preoffersList.isLoading) 
    return <Loaders.TableLoader />

  return (
    <ErrorBoundary>
      {/* <Paginator
        theme='dark'
        onPage={pageConfig.setPage}
        meta={preoffersList.data.pagy}
      /> */}
      <ResponsiveTable title="Pre-launches" columns={columns} data={tableData} onClickRow={openPreofferView} />
    </ErrorBoundary>
  );
}

PreoffersList.defaultProps = {};

PreoffersList.propTypes = {};

export default PreoffersList;